// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: flex;
  color: #fff;
  width: 100%;
  top: 0;
  z-index: 111;
}
:host nav {
  background-color: var(--cs-secondary-color);
  flex-flow: row nowrap;
  width: 100%;
  min-height: 10px;
  height: 62px;
  max-height: 62px;
  padding: 0 1rem;
}
:host .pl-2rem {
  padding-left: 2rem;
}
:host .cs-nav-controls {
  height: 100%;
}
:host .cs-nav-controls .cs-nav-control-item {
  padding-left: 1rem;
  height: 100%;
  display: flex;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-item {
  font-family: Roboto-Light;
  padding: 0.5rem 1.5rem;
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  display: flex;
  cursor: pointer;
  height: 100%;
  flex-direction: column;
  text-align: center;
  letter-spacing: 0.3px;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-item:hover {
  color: #fff;
  background: var(--cs-secondary-color);
  filter: brightness(1.2);
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-item.cs-menu-item-active {
  color: #fff;
  background: var(--cs-secondary-color);
  filter: brightness(1.2);
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-item .cs-menu-icon {
  margin: auto;
  width: 14px;
  height: 14px;
  line-height: 14px;
  margin-bottom: 5px;
  margin-top: 5px;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-trigger {
  flex-direction: row;
  padding-right: 0.75rem;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-trigger .name-icon {
  display: flex;
  flex-direction: column;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-trigger .down-arrow {
  margin: auto;
  margin-left: 0.5rem;
  margin-bottom: 0.7rem;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-trigger:hover .cs-menu-drop-down-panel {
  display: block;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-panel {
  background: var(--cs-secondary-color);
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-panel a {
  text-decoration: none;
  color: inherit;
  font-family: Roboto-Light;
  display: block;
  width: 100%;
  height: 100%;
  padding-left: 16px;
  text-align: left;
  padding: 0.8rem 1.5rem;
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  line-height: 1rem;
}
:host .cs-nav-controls .cs-nav-control-item .cs-menu-drop-down-panel ul {
  list-style: none;
  line-height: 2;
  padding: 0;
  margin-bottom: 0;
  text-transform: capitalize;
}
:host .cs-nav-controls .cs-nav-control-item .property-settings,
:host .cs-nav-controls .cs-nav-control-item .notification,
:host .cs-nav-controls .cs-nav-control-item .drop-down {
  color: rgb(219, 228, 238);
}
:host .cs-nav-controls .cs-nav-control-item .notification,
:host .cs-nav-controls .cs-nav-control-item .property-settings {
  width: 18px;
  height: 18px;
}
:host .cs-nav-controls .cs-nav-control-item .account {
  cursor: pointer;
}
:host .cs-nav-controls .cs-nav-control-item .account cs-icon {
  color: var(--cs-primary-color);
  font-size: 1rem;
  font-weight: 400;
}
:host .cs-nav-controls .cs-nav-control-item .account:hover {
  color: rgba(255, 255, 255, 0.75);
}
:host .cs-nav-controls .icon-separator {
  margin-left: 1rem;
  background: #fff;
  width: 1px;
  height: 100%;
  display: block;
  opacity: 0.5;
}
:host .cs-nav-controls .switch-organization img {
  width: 30px;
  height: 30px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 50%;
}
:host .cs-nav-controls .switch-organization span {
  color: rgba(255, 255, 255, 0.75);
}
:host .ai-assistant-btn .ai-assistant-toggle {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  height: 100%;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-family: Roboto-Medium;
  font-size: 13px;
}
:host .ai-assistant-btn .ai-assistant-toggle .cs-menu-icon {
  width: 16px;
  height: 16px;
}
:host .ai-assistant-btn .ai-assistant-toggle:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}
:host .ai-assistant-btn .ai-assistant-toggle.ai-assistant-toggle-active {
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
